/**
 * Return the viewer element. It is the div with class name "document" in DocumentContainer.js
 */
export default () => window.documentViewer.getViewerElement();
